import localforage from 'localforage';

export const setLocalForage = async (key: string, data: any) => {
    await localforage.setItem(key, data);
}

export const getLocalForage = async (key: string) => {
    return await localforage.getItem(key);
}

export const deleteLocalForage = async (key: string) => {
   return await localforage.removeItem(key);
}

export const deleteAllLocalForage = async () => {
    return await localforage.clear()
}

export const getAllLocalForageKeys = async () => {
    return await localforage.keys();
}

export const cleanLocalForage = async (count: number) => {
    const keys = await localforage.keys();
    if (keys.length > count) {
        for (const key of keys) {
            const index = keys.indexOf(key);
            if (index > count) {
                await localforage.removeItem(key);
            }
        }
    }
}

export const setLocalStorage = (key: string, value: any, boardId?: string) => {
    if (boardId && key === 'conversionId') {
        const conversationId = getLocalStorage(key);
        if (conversationId) {
            try {
                const conversionMap = JSON.parse(conversationId);
                localStorage.setItem(key, JSON.stringify({...conversionMap, [boardId]: value}));
            } catch (e) {
                localStorage.setItem(key, JSON.stringify({[boardId]: value}));
            }
        }else {
            localStorage.setItem(key, JSON.stringify({[boardId]: value}));
        }
    }else {
        localStorage.setItem(key, value);
    }
}

export const getLocalConversionId = (boardId?: string) =>{
    const conversationId = getLocalStorage('conversionId');
    if (conversationId && boardId) {
        try {
            const conversionMap = JSON.parse(conversationId);
            return  conversionMap[boardId] ?? null
        }catch (e) {
            return conversationId
        }
    }else {
        return null
    }
}

export const deleteLocalConversionId = (boardId?: string) => {
    const conversationId = getLocalStorage('conversionId');
    const exist = getLocalConversionId(boardId);
    if (conversationId && boardId && exist) {
        try {
            const conversionMap = JSON.parse(conversationId);
            delete conversionMap[boardId];
            setLocalStorage('conversionId', JSON.stringify(conversionMap));
            return true;
        } catch (e) {
            console.error('Failed to delete conversionId for boardId:', boardId, e);
            return false;
        }
    } else {
        return false;
    }
}

export const getLocalStorage = (key: string) => {
    return localStorage.getItem(key);
}

export const deleteLocalStorage = (key: string) => {
    localStorage.removeItem(key);
}

export const getLang = () => {
    let lang = getLocalStorage('i18nextLng');
    if (lang === 'zh') lang = 'zh-CN'
    if (lang === 'en') lang = 'en-US'
    if (lang === 'ja') lang = 'ja-JP'
    return lang || 'zh-cn'
}